import React, { useState } from 'react';
import styled from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import useTranslator from '../../../hooks/useTranslator';
import NormalizedWrapper from './Normalizer';

const Wrapper = styled.div`
    margin-top: 1em;
    display: block;
`;

const ShowMoreBtn = styled.button`
    display: block;
    ${forDesktop`
        display: none;
    `}
`;

const ContentWrapper = styled(NormalizedWrapper)<{ open: boolean }>`
    display: ${({ open }) => `${open ? 'block' : 'none'}`};

    ${forDesktop`
        display: block;
    `}
`;

const SeoTextBottom: React.SFC<{ rawHtml: string; name: string }> = ({ rawHtml, name }) => {
    const t = useTranslator();
    const [isOpen, setIsOpen] = useState(false);

    if (rawHtml === '') {
        return null;
    }

    const handleOpenBtnClick = () => {
        setIsOpen(!isOpen);
    };

    const openBtnText = isOpen ? t('Read less about %s', [name]) : t('Read more about %s', [name]);
    return (
        <Wrapper>
            <ShowMoreBtn type="button" data-testid="seo_bot_toggle_btn" onClick={handleOpenBtnClick}>
                {openBtnText}
            </ShowMoreBtn>
            <ContentWrapper data-testid="seo_bot_content" open={isOpen} dangerouslySetInnerHTML={{ __html: rawHtml }} />
        </Wrapper>
    );
};

export default SeoTextBottom;
